import type {DefaultsInstance} from 'vuetify/lib/framework.mjs'

export enum EVuetifyDefaults {
    DEFAULT = 'defaultDefaults',
}

export const defaults: DefaultsInstance = {
    global: {
        ripple: false,
    },
    VBtn: {
        variant: 'flat',
        color: 'primary',
        size: 'default',
        //style:  'font-family: Karla-Regular;',
        elevation: 0,
    },
    VAppBar:{
        elevation: 0,
    }
}

export default defaults
